<template>
  <v-container fluid pa-0 pm-0 @click="keepSessionActive()">    
    <div class="fullpage-container">
      <div class="fullpage-wp" v-fullpage="opts" ref="fullpage">

        <div class="intro-page page">
          <router-view />
          <session-usage-survey
            :show="showSessionUsageSurvey"
            :sessionToUpdate="lastIncompleteSession"
            v-on:did-apply="applySessionUsageSurvey"
            v-on:close-dialog="closeSessionUsageSurvey"
          >
          </session-usage-survey>

          <introduction
            :fullpage-controller="fullpageController"
          >
          </introduction>
        </div>
        <div v-if="authenticated" class="app-page page">
          <app-selector
            :fullpage-controller="fullpageController"
          ></app-selector>
        </div>
      </div>
    </div>

  </v-container>        
</template>

<script>

export default {
  name: 'Home',
  data () {    
    return {
      authenticated: false,
      pagingEnabled: false,

      opts: {
        start: 0,
        dir: 'v',
        duration: 100,
        overflow: 'auto',
        beforeChange: this.allowPaging,
        afterChange: this.afterPageChanged
      },

      drawer: true,
      fixed: false,
      items: [{
        icon: 'bubble_chart',
        title: 'Inspire'
      }],
      miniVariant: false,
      right: true,
      rightDrawer: false,
      title: 'Vuetify.js',
      sessionRefreshingInterval: null,
      sessionIdleTimeout: null,
      showSessionUsageSurvey: false,
      lastIncompleteSession: null
    }
  },

  computed: {
  },

  created: function() {
    this.isAuthenticated()
  },

  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    new Promise((resolve) => {
      setTimeout(async () => {
        console.log("mounted")
        const authenticated = await this.$auth.isAuthenticated()
        console.log(`async: ${authenticated}`)

        resolve(authenticated)
      }, 100)
    }).then((authenticated) => {
      if(!authenticated) return
      
      this.sessionRefreshingInterval = setInterval(() => {
        if(this.$cookies.get("sessionInitStatus") != "done"){
          return this.$store.dispatch('initializeSessionDetails')
        }
        this.$store.dispatch('refreshSessionTokens')
        this.$store.dispatch('updateSessionEndTime')
      }, 1 * 60 * 1000)
      this.keepSessionActive()
    })

    // if(!this.authenticated) {
    //   this.$auth.loginRedirect('/')
    // }
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
    this.cancelSessionRefreshingInterval()
  },

  watch: {
    '$route': 'isAuthenticated'
  },

  methods:{
    async isAuthenticated() {
      console.log("before")

      this.authenticated = await this.$auth.isAuthenticated()
      console.log(`after: ${this.authenticated}`)
    },

    login() {
      this.$auth.loginRedirect('/')
    },

    fullpageController() {
      return this.$refs.fullpage.$fullpage
    },
    handleResize() {
      this.$refs.fullpage.$fullpage.resize()
    },

    allowPaging() {
      return this.pagingEnabled
    },
    afterPageChanged() { 
      this.pagingEnabled = false 
    },
    startSessionRefreshingInterval() {
      return setInterval(() => {
        if(this.$cookies.get("sessionInitStatus") != "done"){
          return this.$store.dispatch('initializeSessionDetails')
        }
        this.$store.dispatch('refreshSessionTokens')
        this.$store.dispatch('updateSessionEndTime')
      }, 1 * 60 * 1000)
    },
    keepSessionActive() {
      if(this.sessionIdleTimeout){
        clearTimeout(this.sessionIdleTimeout)
      }
      this.sessionIdleTimeout = setTimeout(() => {
        this.cancelSessionRefreshingInterval()
        this.$store.dispatch('closeSession')
      }, 30 * 60 * 1000)
      if(!(this.$cookies.isKey("sessionInitStatus") && this.$cookies.isKey("sessionId"))){
        this.$store.dispatch('initializeSessionDetails')
        this.cancelSessionRefreshingInterval()
        this.sessionRefreshingInterval = this.startSessionRefreshingInterval()
      }
    },
    cancelSessionRefreshingInterval() {
      if(this.sessionRefreshingInterval){
        clearInterval(this.sessionRefreshingInterval)
      }
    },
    applySessionUsageSurvey(v) {
      if(this.lastIncompleteSession){
        v.sessionId = this.lastIncompleteSession.sessionId
        this.$store.dispatch('updateSessionUsageData', v)
        this.lastIncompleteSession = null
        this.$cookies.remove('lastIncompleteSession')
      }
      this.showSessionUsageSurvey = false
    },
    closeSessionUsageSurvey() {
      if(this.lastIncompleteSession){
        this.lastIncompleteSession = null
      }
      this.showSessionUsageSurvey = false
    },
  },
  components: {
    'session-usage-survey': () => import ('@/components/SessionUsageSurvey')
  }
}
</script>




<style scoped>
.fullpage-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.page {
  color: #eee;
  font-family: Roboto, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.intro-page {
  text-align: center;
  background-color: #A2B3CE;
  background: url("../assets/WhiteLayered.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.app-page {
  background-color: #EEEEEE;
}

</style>

